import ContentHideApi from './ContentHideApi';
export default ContentHideApi;
